<template>
  <svg class="icon" aria-hidden="true">
    <use v-bind:xlink:href="`#${type}`"></use>
  </svg>
</template>

<script>
import { ref, computed } from 'vue';
export default {
  name: 'icon-font',
  props: {
    type: {
      required: true,
    },
  },

  setup(props) {
    // const type = computed(() => props.type);
    //
    // return {
    //   type,
    // };
  },
};
</script>

<style scoped lang="less">
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
